module.exports = __webpack_public_path__ + "static/media/ic_plc_fabric_colored.9af3c235.svg";